<template>
  <el-tabs tab-position="left" v-model="tabActive">
    <el-tab-pane label="Lbq" name="Lbq">
      <LastResultTabData :data="allData.Lbq"/>
    </el-tab-pane>
    <el-tab-pane label="Endless" name="Endless">
      <LastResultTabData :data="allData.Endless"/>
    </el-tab-pane>
    <el-tab-pane label="RaidbossGrand" name="RaidbossGrand">
      <LastResultTabData :data="allData.RbGrand"/>
    </el-tab-pane>
    <el-tab-pane label="RaidbossLittle" name="RaidbossLittle">
      <LastResultTabData :data="allData.RbLittle"/>
    </el-tab-pane>
    <el-tab-pane label="Versus" name="Versus">
      <LastResultTabData :data="allData.Versus"/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>

import LastResultTabData from "./LastResultTabData.vue"

function noop() {}

export default {
  name: "event",
  components: {
    LastResultTabData
  },
  props: {
    allData : {},
  },
  data: () => {
    return {
      tabActive: "Lbq",
    }
  },
  methods: {
  }
};

</script>